var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-box"},[(_vm.title || _vm.$slots.header)?_c('div',{staticClass:"m-box-header"},[_vm._t("header",[_vm._v(_vm._s(_vm.title))]),_vm._t("link")],2):_vm._e(),_c('div',{staticClass:"m-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }